var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-group"},_vm._l((_vm.values),function(val,key){return _c('button',{key:val+key,class:['btn', { 'btn-primary': _vm.selected === val, 'btn-default': _vm.selected !== val }],attrs:{"type":"button"},on:{"click":function($event){return _vm.changeSelectVal(val)}}},[_vm._v(_vm._s(val)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }